export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOG_IN_REQESTED = 'USER_LOG_IN_REQESTED';
export const USER_LOG_IN_ERROR = 'USER_LOG_IN_ERROR';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_INITIAL = 'RESET_INITIAL';
